import React from 'react';
import '../styles/LatestPassOn.css';

const LatestPassOn = ({ passOn, previousPassOn }) => {
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'Unknown time';
    
    // Handle Firestore Timestamp
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleString();
    }
    
    // Handle regular Date or string
    return new Date(timestamp).toLocaleString();
  };

  if (!passOn) {
    return (
      <div className="latest-pass-on">
        <div className="pass-on-card">
          <p className="no-messages">No messages yet. Be the first to give it to the next person!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="latest-pass-on">
      <div className="pass-on-card">
        <div className="pass-on-header">
          <div className="pass-on-meta">
            <h3 className="pass-on-name">
              {previousPassOn 
                ? `${passOn.title || passOn.name || 'Anonymous'} replied to ${previousPassOn.title || previousPassOn.name || 'Anonymous'}:`
                : `${passOn.title || passOn.name || 'Anonymous'} said:`
              }
            </h3>
            <span className="pass-on-timestamp">
              {formatTimestamp(passOn.createdAt || passOn.timestamp)}
            </span>
          </div>
        </div>
        <div className="pass-on-content">
          <h3 className="pass-on-message">
            {passOn.description || passOn.text}
          </h3> 
          {(passOn.gifUrl || passOn.imageUrl) && (
            <div className="pass-on-image">
              <img 
                src={passOn.gifUrl || passOn.imageUrl} 
                alt="Pass-on content"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LatestPassOn;